import { gql } from '@apollo/client';

const SET_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation SetAllNotificationsAsRead {
    setAllNotificationsAsRead
  }
`;

export default SET_ALL_NOTIFICATIONS_AS_READ;
